import { useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { OwnerParams } from 'shared/types';
import { cancelVisit } from 'store/visits/actions';

export const useCancelVisitAction = (visitId: string) => {
  const dispatch = useDispatch();
  const { ownerId } = useParams<OwnerParams>();

  return useCallback(() => {
    dispatch(cancelVisit.request({ buildingId: ownerId, visitId }));
  }, [dispatch, ownerId, visitId]);
};
